<template>
  <div class="clear-both"></div>
  <div class="container">
    <div class="row">
      <div class="flex justify-between">
        <div class="w-1/2 p-4">
          <h2>Link Forms</h2>
          <div v-for="(link, key) in shareInformation" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">{{ key }}</label>
              <input :id="'input-' + key" type="text" v-model="shareInformation[key]" class="form-input"/>
            </div>
          </div>
          <h2 class="mt-5">Link Forms for API Domains</h2>
          <div v-for="(domain, index) in apiDomainsInformation" :key="'form-domain-' + index">
            <div>
              <label :for="'input-domain-' + index" class="form-label mt-5">Domain Link {{ index + 1 }}</label>
              <input :id="'input-domain-' + index" class="form-input" type="text" v-model="apiDomainsInformation[index]" />
            </div>
          </div>
          <h2 class="mt-5">Tracking Domains</h2>
          <div v-for="(domain, index) in trackingDomains" :key="'form-tracking-domain-' + index">
            <div>
              <label :for="'input-tracking-domain-' + index" class="form-label mt-5">Tracking Domain {{ index + 1 }}</label>
              <input :id="'input-tracking-domain-' + index" class="form-input" type="text" v-model="trackingDomains[index]" />
            </div>
          </div>
          <h2 class="mt-5">Update Link</h2>
          <div v-for="(link, index) in updateApplication" :key="'form-update-application-' + index">
            <div>
              <label :for="'input-update-link-' + index" class="form-label mt-5">{{ index + 1 }}</label>
              <input :id="'input-update-link-' + index" class="form-input" type="text" v-model="updateApplication[index]" />
            </div>
          </div>
          <h2 class="mt-5">Share + Account</h2>
          <div v-for="(link, index) in additionalLinkForApplication" :key="'form-share-link-' + index">
            <div>
              <label :for="'input-share-link-' + index" class="form-label mt-5">{{ index + 1 }}</label>
              <input :id="'input-share-link-' + index" class="form-input" type="text" v-model="additionalLinkForApplication[index]" />
            </div>
          </div>
        </div>
        <div class="w-1/2 p-4">
          <pre>{{ jsonString }}</pre>
        </div>
      </div>
    </div>

    <loading-button :loading="loading" @click="submitLink" class="mt-5 btn-indigo ml-auto">
      Save Data
    </loading-button>
  </div>
</template>

<script>
import axios from 'axios';
import {Head} from "@inertiajs/vue3";
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  props: {
    config: Object,
    guid: String,
    appName: String,
  },
  layout: Layout,
  data() {
    return {
      loading: false,
      guid: this.guid,
      shareInformation: this.config.shareInformation,
      apiDomainsInformation: this.config.apiDomainsInformation,
      trackingDomains: this.config.trackingDomains,
      updateApplication: this.config.updateApplication,
      additionalLinkForApplication: this.config.additionalLinkForApplication,
    };
  },
  methods: {
    submitLink() {
      this.loading = true;
      axios.post('/api/config/update-batch',
          {
            data: {
              shareInformation: this.shareInformation,
              apiDomainsInformation: this.apiDomainsInformation,
              trackingDomains: this.trackingDomains,
              updateApplication: this.updateApplication,
              additionalLinkForApplication:this.additionalLinkForApplication,
            },
            guid: this.guid,
            appName: this.appName
          })
          .then(response => {
            this.loading = false;
            alert(`Update is queued`);
          })
          .catch(error => {
            console.error(`Error saving ${key}:`, error);
            alert(`Failed to save ${key}.`);
          });
    },
    serialize(obj) {
      const result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] !== 'function') {
            result[key] = obj[key];
          }
        }
      }
      return result;
    }
  },
  mounted() {
    console.log(this.config);
  },
  computed: {
    jsonString() {
      const dataForJson = this.serialize(this.config);
      return JSON.stringify(dataForJson, null, 2);
    }
  }
}
</script>
